const MAX_RETRIES = 4
const RETRY_DELAY = 500

export const loadStylesWithRetry = async (
  node: Node,
  src: string,
  retries = MAX_RETRIES,
  delay = RETRY_DELAY
): Promise<void> => {
  await new Promise<void>((resolve, reject) => {
    const attempt = (remainingRetries: number) => {
      const link = document.createElement('link')

      link.rel = 'stylesheet'
      link.href = src
      link.type = 'text/css'

      link.onload = () => resolve()
      link.onerror = () => {
        link.onerror = link.onload = null
        link.remove()
        if (remainingRetries > 0) {
          setTimeout(() => attempt(remainingRetries - 1), delay)
        } else {
          reject(new Error(`Failed to load styles after ${retries} retries: ${src}`))
        }
      }

      node.appendChild(link)
    }

    attempt(retries)
  })
}
